<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ action !== 'edit' ? $t(`${namespace}.paymentMethod`) : $t(`${namespace}.changePaymentMethod`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-btn
        v-if="hasRole('billing', 'ROLE_PUT_CREDIT_CARD') && action === 'preview'"
        color="gray-6"
        class="mx-0"
        slot="activator"
        flat
        icon
        @click="handleEditProject"
      >
        <v-icon>edit</v-icon>
      </v-btn>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    action: {
      type: String,
      required: true
    },

    paymentMethod: {
      type: String
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.paymentMethod.header'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    handleEditProject () {
      const action = this.paymentMethod === 'CREDIT_CARD' ? 'edit' : 'editConfirm'
      this.$emit('toggleAction', action)
    }
  }
}
</script>
